import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getImsiTypes = async (token) => {
    log("welcome in getImsiTypes")

    if (!token || token === "") {
        return {error: true, message: "No token provided", imsi_types: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_imsi_types_api'
        const result = await axios.get(url, {headers: headers})
        return result.data
    } catch (err) {
        log("Error in getImsiTypes")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getImsiTypes", imsi_types: []}
    }
}

export const addImsiType = async (token, data) => {
    log("welcome in addImsiType")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/add_imsi_type_api'
        const result = await axios.post(url, { name: data.name }, {headers: headers})
        return result.data
    } catch (err) {
        log("Error in addImsiType")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la addImsiType"}
    }
}

export const updateImsiType = async (token, data) => {
    log("welcome in updateImsiType")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/update_imsi_type_api'
        const result = await axios.put(url, { id: data.id, name: data.name }, {headers: headers})
        return result.data
    } catch (err) {
        log("Error in updateImsiType")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la updateImsiType"}
    }
}

export const deleteImsiType = async (token, id) => {
    log("welcome in deleteImsiType")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/delete_imsi_type_api'
        const result = await axios.delete(url, {headers: headers, data: {id: id}})
        return result.data
    } catch (err) {
        log("Error in deleteImsiType")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la deleteImsiType"}
    }
}

export default () => {
    return {
        error,
        getImsiTypes,
        addImsiType,
        updateImsiType,
        deleteImsiType
    }
}
